import { useState } from 'react';

import { ReactSearchAutocomplete } from 'react-search-autocomplete';

import { Container, MainContainer, Wrapper, Title, Image, ResultsContainer, ResultsWrapper, VetDetail, Text, Button } from './styles';

import hospital from '../../assets/images/hospital.svg'
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAxios from '../../context/hooks/useAxios';

function Units() {
  const [addresses, setAddresses] = useState([]);
  const [allUnits, setAllUnits] = useState([]);
  const [units, setUnits] = useState([]);
  const { fetchUnits, response } = useAxios();

  useEffect(() => {
    fetchUnits()
  }, [fetchUnits]);

  useEffect(() => {
    if (response) {
      setAllUnits(response);
      setAddresses([...new Map(response.map(unit => [unit.endereco.cidade, unit.endereco])).values()])
    }
  }, [response]);

  const handleOnSelect = (address) => {
    setUnits(allUnits.filter((unit) => unit.endereco.cidade === address.cidade));
  }

  const handleOnClear = () => {
    setUnits([]);
  }

  const navigate = useNavigate();

  return (
    <Container>
      <MainContainer>
        <Wrapper>
          <Title color='#000'>
            Encontre unidades, estabelecimentos, clinicas, hospitais e laboratórios veterinários próximos de você.
          </Title>
          <ReactSearchAutocomplete
            items={addresses}
            fuseOptions={
              { 
                keys: ["cidade"],
                threshold: 0.5,
                minMatchCharLength: 2
              }
            }
            resultStringKeyName="cidade"
            placeholder='Procure aqui a cidade'
            autoFocus
            onSelect={handleOnSelect}
            onClear={handleOnClear}
            showNoResultsText="Sem resultados"
            styling={{

              borderRadius: "8px",
              backgroundColor: "#E6E6E6",
              color: "#555",
              fontFamily: "Poppins",
              hoverBackgroundColor: "#E0E0E0",
              placeholderColor: "black"
            }}
          />
        </Wrapper>
        {units.length === 0 && <Image src={hospital} />}
      </MainContainer>
      {
        units.length !== 0 &&
        <ResultsContainer>
          <Title color='#168C5A'>Veterinários em cidade: </Title>
          <ResultsWrapper>
            {
              units.map(unit => {
                return (
                  <VetDetail key={unit.nome}>
                    <Text>{unit.nome} - {unit.endereco.bairro}</Text>
                    <Button onClick={() => navigate(`/unidades/${unit.id}`)}>VER DETALHES</Button>
                  </VetDetail>
                )
              })
            }

          </ResultsWrapper>
        </ResultsContainer>
      }
    </Container>
  )
}

export default Units;